module.exports = __webpack_public_path__ + "assets/img/HTML.988d159b.png";